<div class="container" [ngClass]="{'text-truncate': isTruncated && !note.visible}" #content>
  {{ note.note }}
</div>
<footer class="blockquote-footer float-left ml-4 capitalize">
  {{ note.createdBy }}
  <cite title="Source Title"> {{ note.createdDate | date }}</cite>
  <div class="float-right">
    <a
      *ngIf="isTruncated"
      class="ml-2 cursor-pointer text-blue-500 hover:text-blue-700"
      (click)="note.visible = !note.visible"
    >
      {{ note.visible ? 'Show less -' : 'Show More +' }}
    </a>
  </div>
</footer>
